// src/components/ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Detect if user is on a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // Choose behavior based on device
    const behavior = isMobile ? "auto" : "smooth";

    // Scroll main window
    window.scrollTo({ top: 0, behavior });

    // Also scroll custom containers (if your layout uses them)
    const main = document.querySelector(".main-content");
    if (main) main.scrollTo({ top: 0, behavior });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
